<template>
    <div
        class="footer-container my-auto w-100 main-area"
        style="min-height: 80px; box-shadow:none; background: #E7F6F6; border-radius:0px; padding: 12px 0;"
        >
        <div class="contact-row" style="text-align:center; font-size: 12px; margin-bottom: 8px;">
            <p style="color: #3c3c3c; margin-bottom: 0;">
                <span class="contact-label">求人情報やその他お問い合わせ先　</span><a href="mailto:info@blm.co.jp" class="email-link">info@blm.co.jp</a>
            </p>
        </div>
        <div class="site-links-row">
            <a href="https://www.blm.co.jp/" target="_blank" class="site-link">
                © Bloom Inc.<i class="fa-solid fa-arrow-up-right-from-square open-icon"></i>
            </a>
            <a href="https://www.blm.co.jp/privacy.html" target="_blank" class="site-link privacy-link">
                プライバシーポリシー<i class="fa-solid fa-arrow-up-right-from-square open-icon"></i>
            </a>
            <a href="https://www.blm.co.jp/security.html" target="_blank" class="site-link security-link">
                <span>情報セキュリティおよび<br>プライバシー保護基本方針<i class="fa-solid fa-arrow-up-right-from-square open-icon"></i></span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
    .footer-container {
        position: relative;
        margin-top: auto;
        width: 100%;
    }
    .site-links-row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
    }
    a {
        color: #3c3c3c;
        text-decoration: none;
        font-size: 12px;
    }
    .email-link {
        text-decoration: underline !important;
        margin-left: 60px;
    }
    .contact-label {
        position: relative;
        left: 40px;
    }
    .site-link {
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: 3px;
        white-space: normal;
    }
    .security-link {
        display: inline;
        margin-left: 40px;
    }
    .privacy-link {
        margin-left: 60px;
    }
    .security-link span {
        display: inline;
    }
    .open-icon {
        font-size: 11px;
        margin-left: 2px;
    }
    @media (max-width: 768px) {
        .site-links-row {
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 6px 12px;
            flex-wrap: wrap;
        }
        .privacy-link {
            margin-left: 0;
        }
        .security-link {
            margin-left: 0;
            display: inline-block;
            text-align: left;
        }
        .security-link span {
            display: block;
        }
        a {
            font-size: 10px;
        }
        .contact-row {
            font-size: 9px !important;
        }
        .contact-label {
            position: relative;
            left: 40px;
        }
        .site-link {
            white-space: normal;
        }
        .open-icon {
            font-size: 9px;
        }
    }
</style>
